
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/sdks/flutter",
      function () {
        return require("private-next-pages/events/sdks/flutter.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/sdks/flutter"])
      });
    }
  